declare const owEssentials: {
    nonce: string;
    endpoint: string;
    debug: boolean;
};

class Plop {
    private debug: boolean = false;

    async execute(): Promise<void> {
        this.debug = owEssentials.debug || localStorage.getItem('plop-debug') === '1';

        const urls = await this.getUrls();
        await this.log('Found URLs', urls);

        for (const url of urls) {
            await this.log('Plopping', url);
            await this.doPlop(url);
        }
    }

    async log(message: string, ...data: any): Promise<void> {
        if (this.debug) {
            console.log(message, ...data);
        }
    }

    private async getUrls(): Promise<string[]> {
        const { endpoint, nonce } = owEssentials;

        try {
            const response = await fetch(endpoint, { method: 'GET', headers: { 'X-WP-Nonce': nonce } });
            return response.json();
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    private async doPlop(url: string): Promise<void> {
        const hash = btoa(encodeURIComponent(url));
        const key = this.debug ? url : `plop-${hash}`;

        const expiration = localStorage.getItem(key);
        if (expiration && parseInt(expiration) > Date.now() / 1000) {
            await this.log('Skipping', url);
            return;
        }

        localStorage.setItem(key, (Math.floor(Date.now() / 1000) + 60 * 60 * 24).toString());

        const id = `plop-${hash.substring(0, 8)}`;
        this.showIframe(url, id);
    }

    private showIframe(url: string, id: string): void {
        const img =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=';
        const wrapperStyle = 'position: relative; display:inline-block';
        const iframeStyle =
            'position: absolute; display: block !important; width: 1px !important; height: 1px !important;';

        const content = [
            `<div class="plop" id="${id}" style="${wrapperStyle}">`,
            `    <a href="${url}">`,
            `        <img src="${img}">`,
            `        <iframe is="x-frame-bypass" src="${url}" scrolling="no" style="${iframeStyle}" frameborder="0"></iframe>`,
            '    </a>',
            '</div>',
        ].join('');

        const node = document.createElement('div');
        node.innerHTML = content;
        document.body.appendChild(node);

        this.log('Iframe created', url);

        const iframe = node.querySelector('iframe') as HTMLIFrameElement;
        if (iframe) {
            iframe.addEventListener('load', () => {
                this.log('Iframe loaded', url);
                setTimeout(() => {
                    this.log('Cleaning up', url);
                    this.cleanUp(id);
                }, 1000);
            });
        }
    }

    private cleanUp(id?: string): void {
        if (id) {
            const node = document.getElementById(id);
            if (node) {
                node.remove();
            }
        } else {
            const nodes = document.querySelectorAll('.plop');
            for (const node of nodes) {
                node.remove();
            }
        }
    }
}

new Plop().execute();
